import { buildComponent } from '../components/factory'
import { useDatasources } from '../hooks/use-datasources'

export const Datasources = buildComponent().withLifecycle(() => {
  useDatasources()
})
